<template>
  <div>
    <img v-if="isPreview && value.url" :src="value.url" class="app-upload-preview">
    <el-upload
      v-else
      action="#"
      class="app-upload"
      :accept="accept"
      :show-file-list="false"
      :http-request="uploadHandler"
      :before-upload="onBeforeUpload"
      :on-success="onUploadSuccess"
    >
      <div v-if="value.url" class="app-upload-picture-card relative" @click.stop>
        <img :src="value.url" class="app-upload-preview">
        <div class="app-upload-preview-mask absolute left-0 top-0 w-full h-full flex items-center justify-center">
          <i class="el-icon-delete delete-icon" @click.stop="onRemoveFile" />
        </div>
      </div>
      <i v-else class="el-icon-plus app-upload-icon" />
      <template #tip>
        <div class="el-upload__tip">{{ tip }}</div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { uploadImagesApi } from '@/api/upload';
import { validateImage } from '@/utils/image';

export default {
  name: 'FormUpload',
  model: {
    prop: 'value',
  },
  props: {
    /** 双向绑定值 - 资源链接 */
    value: {
      type: Object,
      default: () => {
        return {
          url: '',
        };
      },
    },
    /** 接受上传的文件类型 */
    accept: {
      type: String,
      default: '.jpg, .jpeg, .png',
    },
    /** 提示文案 */
    tip: {
      type: String,
      default: '',
    },
    /** 上传限制 */
    restriction: {
      type: Object,
      default: () => {},
    },
    /** 是否存储上传文件 */
    isFile: {
      type: Boolean,
      default: false,
    },
    /** 是否预览 */
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 上传处理器
     * @param {Object} file_data 上传的文件对象
     * @returns {Promise}
     */
    uploadHandler(file_data) {
      const form_data = new FormData();
      form_data.append('images[]', file_data.file);
      return uploadImagesApi(form_data);
    },
    /**
     * 文件上传之前的钩子
     * @param file_data 文件对象
     * @returns {Promise<Boolean>}
     */
    onBeforeUpload(file_data) {
      return validateImage(file_data, this.restriction);
    },
    /**
     * 文件上传成功
     * @param {Object} response 接口响应值
     * @param {Object} file 上传的文件对象
     * @returns {void}
     */
    onUploadSuccess(response, file) {
      const url = response.data[0].url;
      Object.assign(this.value, { url });
      this.isFile && Object.assign(this.value, { file: file.raw });
      this.$emit('formItemValidateField');
    },
    /**
     * 移除文件
     * @returns {void}
     */
    onRemoveFile() {
      Object.assign(this.value, { url: '', ...(this.isFile && { file: null }) });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-upload {
  /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.app-upload .el-upload:hover {
  border-color: #409EFF;
}
.app-upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.app-upload-preview {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
.app-upload-picture-card {
  width: fit-content;
  height: fit-content;
  &:hover {
    .app-upload-preview-mask {
      display: flex;
      opacity: 1;
    }
  }
  .app-upload-preview-mask {
    background-color: rgba(0, 0, 0, .5);
    z-index: 10;
    cursor: pointer;
    display: none;
    opacity: 0;
    transition: opacity .3s;
    .delete-icon {
      font-size: 24px;
      color: #fff;
    }
  }
}
</style>
